<template>
  <main class="main-content" style="width: 800px; background-color: white">
    <h2>农技论坛</h2>
    <div
      v-for="(post, index) in posts"
      :key="index"
      class="container"
      style="width: 100%; background-color: white; display: flex"
    >
      <div class="avatar"><img :src="post.avatar" /></div>
      <div
        style="background-color: white; display: grid; justify-items: start; width: 100%"
      >
        <div>{{ post.creator_name }}</div>
        <div>{{ post.createtime }}</div>
        <div>
          <b>{{ post.title }}</b>
        </div>
        <div style="position: relative">
          <div>
            <div
              v-if="post.showSumary"
              style="text-align: left"
              v-html="post.contentSummary"
            ></div>
            <div v-else style="text-align: left" v-html="post.content"></div>
          </div>
          <div
            v-if="post.showSumary"
            style="
              position: absolute;
              bottom: 0px;
              right: 10px;
              width: 32px;
              height: 21px;
              color: #0db3a7;
              font-size: 16px;
              font-style: normal;
              cursor: pointer;
            "
            @click="showAllContent(index)"
          >
            更多
          </div>
        </div>
        <div><img :src="post.cover" style="border-radius: 8px" /></div>
        <div style="display: flex; justify-content: space-between; width: 100%">
          <div>
            <img src="@/image/eye.png" />
            {{ post.readcount }}
          </div>
          <div style="cursor: pointer" @click="clickThumb(index, post.id)">
            <img src="@/image/thumb.png" />
            {{ post.likecount }}
          </div>
          <div
            v-if="!post.showRemark"
            style="cursor: pointer"
            @click="post.showRemark = true"
          >
            <img src="@/image/remark.png" />
            {{ post.remarkcount }}
          </div>
          <div v-else>
            <img src="@/image/remark2.png" />
            {{ post.remarkcount }}
          </div>
        </div>
        <div v-if="post.showRemark">
          <el-input v-model="post.new_remark" placeholder="请输入" />
          <el-button type="primary" class="xin" @click="newRemark()">新增</el-button>
          <hr class="colorful-line" />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// import { ElMessage } from "element-plus";
import {
  ref,
  onMounted,
  // onMounted
} from "vue";

import { getPostSummaryList, thumbPlus } from "@/api/api";

export default {
  setup() {
    const posts = ref([]);

    const clickThumb = (index, postid) => {
      console.log("clickThumb(): postid=", postid, "index=", index);

      thumbPlus({ id: postid }).then((res) => {
        console.log("thumbPlus(): res=", res, "posts=", posts);

        // let p = posts.value;
        // p.likecount = res.count;
        // posts.value = p;

        posts.value[index].likecount = res.count;
      });
    };

    function init() {
      // posts.value[0].title = "aaa";

      GetPostSummaryList();
      // initCommonImage();
    }

    function GetPostSummaryList() {
      getPostSummaryList().then((res) => {
        console.log("GetPostSummaryList(): res=", res);
        posts.value = res.data;
      });
    }

    function showAllContent(index) {
      console.log("showAllContent(): index=", index);
      posts.value[index].showSumary = false;
    }

    // function initCommonImage() {
    //   getCommonImage().then((res) => {
    //     console.log("getCommonImage(): res=", res);
    //     commonImage.value = res;
    //   });
    // }

    // function clickRemark(index) {
    //   curPost.value.index = index;
    // }

    onMounted(() => {
      init();
    });

    return {
      posts,
      // curPost,

      clickThumb,
      showAllContent,
      // clickRemark,
    };
  },
};
</script>

<style scoped>
.main-content {
  flex: 1;
  padding: 10px;
  background-color: #fff;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
}
.post {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.post-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.post-content {
  font-size: 14px;
  color: #333;
}

.colorful-line {
  height: 4px;
  border: none;
  background: linear-gradient(90deg, red, orange, yellow, green, blue, indigo, violet);
}
</style>
